import { DIRECTIONS } from '../constants';

// Right Direction Balls
import RIGHT_1 from '../assets/ballAnimations/right (1).glb';
import RIGHT_2 from '../assets/ballAnimations/right (2).glb';
import RIGHT_3 from '../assets/ballAnimations/right (3).glb';
import RIGHT_4 from '../assets/ballAnimations/right (4).glb';
import RIGHT_5 from '../assets/ballAnimations/right (5).glb';
import RIGHT_6 from '../assets/ballAnimations/right (6).glb';

// Left Direction Balls
import LEFT_1 from '../assets/ballAnimations/left (1).glb';
import LEFT_2 from '../assets/ballAnimations/left (2).glb';
import LEFT_3 from '../assets/ballAnimations/left (3).glb';
import LEFT_4 from '../assets/ballAnimations/left (4).glb';
import LEFT_5 from '../assets/ballAnimations/left (5).glb';
import LEFT_6 from '../assets/ballAnimations/left (6).glb';
import LEFT_7 from '../assets/ballAnimations/left (7).glb';

export const BallGlbFiles = {
  [DIRECTIONS.RIGHT]: [RIGHT_1, RIGHT_2, RIGHT_3, RIGHT_4, RIGHT_5, RIGHT_6],
  [DIRECTIONS.LEFT]: [LEFT_1, LEFT_2, LEFT_3, LEFT_4, LEFT_5, LEFT_6, LEFT_7],
};
